<template>
  <div class="gk-badge" v-b-tooltip.hover :title="computedTooltipText" :class="computedClasses">
    <template v-if="!iconOnly">
      <span v-if="iconRight">{{ text }}</span>
      <font-awesome-icon v-if="icon" :icon="icon" class="gk-badge-icon" />
      <slot name="icon" />
      <span v-if="!iconRight">{{ text }}</span>
      <span v-if="extra" class="extra">{{ extra }}</span>
    </template>
    <template v-if="iconOnly">
      <font-awesome-icon v-if="icon" :icon="icon" class="gk-badge-icon" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: 'GkBadge',
  props: {
    type: {
      type: String,
      default: 'premium'
    },
    variant: {
      type: String,
      default: 'light-ghost'
    },
    text: {
      type: String,
      default: '',
    },
    extra: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconRight: {
      type: Boolean,
      default: false    
    },
    iconOnly: {
      type: Boolean,
      default: false    
    },
    size: {
      type: String,
      default: 'sm'
    },
    onlyBasic: {
      type: Boolean,
      default: false    
    },
    tooltipText: {
      type: String,
      default: null
    },
    hideTooltip: {
      type: Boolean,
      default: false
    },
    noShadow: {
      type: Boolean,
      default: false
    },
    accountBadge: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters ({
      currentCompany: "main/getCurrentCompany",
    }),
    computedClasses () {
      const isPremium = this.currentCompany.is_premium;
      let variantType = (isPremium && this.iconOnly) ? 'light-ghost' : this.variant;
      if (this.accountBadge) {
        variantType = 'account-badge'
      }
      return {
        [`gk-badge--${this.type}`]: true,
        [`gk-badge--${this.type}__${variantType}`]: true,
        [`gk-badge--${this.size}`]: true,
        'icon-only': this.iconOnly,
        'badge-hidden': this.onlyBasic && isPremium,
        'is-premium': isPremium,
        'no-shadow': this.noShadow
      }
    },
    computedTooltipText () {
      let tooltip_text = ''

      // If tooltip is not hidden, but company is premium, return empty
      if (!this.hideTooltip) {
        if (this.currentCompany.is_premium) {
          tooltip_text = ''
        } else if (this.tooltipText) {
          tooltip_text = this.tooltipText
        } else {
          tooltip_text = this.$gettext('Premium feature')
        }
      }
      return tooltip_text
    }
  },
  watch: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.gk-badge {
  width: auto !important;
  min-width: auto !important;
  border-radius: $radiusXl;
  padding: 0.25rem 0.5rem;
  display: inline-block;
  box-shadow: $dropdownShadow;
  &.no-shadow { box-shadow: none; }
  .extra {
    position: relative;
    padding-left: 10px;
    &:before {
      content: "";
      left: 4px;
      position: absolute;
      width: 1px;
      height: 100%;
      background: currentColor;
      top: 0;
      opacity: 0.5;
    }
  }
  &.badge-hidden {
    display: none !important;
  }
  &.icon-only {
    aspect-ratio: 1;
    width: 22px !important;
    height: 22px !important;
    font-size: 12px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    .svg-inline--fa {
      margin: 0 !important;
    }
  }
  &.is-premium {
    box-shadow: none;
  }
  &--sm {
    font-size: 12px !important;
  }
  &--md {
    font-size: 14px !important;
  }
  &--lg {
    font-size: 18px !important;
  }
}
</style>
